/* Evinim ortak davranışlar: reveal, paralaks, kaydırıcı okları, sayaçlar.
   Horizon'da masaüstünde (>=990px) kaydırma .page-wrapper üzerinde olur. */
(() => {
  const root = document.documentElement;
  root.classList.add('ev-js');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');

  /* ---------- Reveal ---------- */
  const revealObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        )
      : null;

  function initReveal(scope = document) {
    scope.querySelectorAll('[data-ev-reveal]:not(.is-visible)').forEach((el) => {
      if (!revealObserver || reduceMotion.matches) {
        el.classList.add('is-visible');
      } else {
        revealObserver.observe(el);
      }
    });
  }

  /* ---------- Count-up ---------- */
  const countObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              countObserver.unobserve(entry.target);
              runCount(entry.target);
            }
          },
          { threshold: 0.4 }
        )
      : null;

  function runCount(el) {
    const target = parseFloat(el.dataset.evCount);
    if (Number.isNaN(target)) return;
    const decimals = (el.dataset.evCount.split('.')[1] || '').length;
    if (reduceMotion.matches) {
      el.textContent = target.toLocaleString('tr-TR', { minimumFractionDigits: decimals });
      return;
    }
    const start = performance.now();
    const duration = 1400;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toLocaleString('tr-TR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  function initCounts(scope = document) {
    scope.querySelectorAll('[data-ev-count]').forEach((el) => {
      if (countObserver) countObserver.observe(el);
      else runCount(el);
    });
  }

  /* ---------- Parallax (yalnızca masaüstü) ---------- */
  let parallaxEls = [];
  let ticking = false;

  function updateParallax() {
    ticking = false;
    if (!desktop.matches || reduceMotion.matches) return;
    const vh = window.innerHeight;
    for (const el of parallaxEls) {
      const host = el.closest('[data-ev-parallax-host]') || el.parentElement;
      const rect = host.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) continue;
      const progress = (vh / 2 - (rect.top + rect.height / 2)) / vh;
      const speed = parseFloat(el.dataset.evParallax) || 0.1;
      el.style.transform = `translate3d(0, ${(progress * speed * 200).toFixed(1)}px, 0)`;
    }
  }

  function requestParallax() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateParallax);
    }
  }

  function initParallax() {
    parallaxEls = Array.from(document.querySelectorAll('[data-ev-parallax]'));
    if (!desktop.matches || reduceMotion.matches) {
      parallaxEls.forEach((el) => (el.style.transform = ''));
      return;
    }
    updateParallax();
  }

  window.addEventListener('scroll', requestParallax, { passive: true });
  document.addEventListener(
    'scroll',
    (event) => {
      if (event.target instanceof Element && event.target.classList.contains('page-wrapper')) requestParallax();
    },
    { passive: true, capture: true }
  );
  window.addEventListener('resize', requestParallax, { passive: true });
  desktop.addEventListener?.('change', initParallax);

  /* ---------- Scroller okları ---------- */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-ev-scroll]');
    if (!btn) return;
    const scroller = document.getElementById(btn.getAttribute('aria-controls'));
    if (!scroller) return;
    const dir = btn.dataset.evScroll === 'prev' ? -1 : 1;
    const item = scroller.firstElementChild;
    const step = item ? item.getBoundingClientRect().width + 16 : scroller.clientWidth * 0.8;
    scroller.scrollBy({ left: dir * step, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  });

  /* ---------- Başlat ---------- */
  function init(scope) {
    initReveal(scope);
    initCounts(scope);
    initParallax();
  }

  window.Evinim = Object.assign(window.Evinim || {}, { init, reduceMotion, desktop });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* ---------- Sepet: sözleşme onayı ve öneri ekleme ----------
   Horizon sepeti yeniden çizerken (morph) içteki script'ler çalışmaz;
   bu yüzden olaylar belge düzeyinde dinlenir. */
(() => {
  const KEY = 'ev-consent';
  const read = () => {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  const write = (v) => {
    try {
      sessionStorage.setItem(KEY, v ? '1' : '0');
    } catch (e) {}
  };

  const syncInputs = () => {
    const state = read();
    document.querySelectorAll('[data-ev-consent-input]').forEach((input) => {
      if (input.checked !== state) input.checked = state;
    });
  };

  document.addEventListener('change', (e) => {
    const input = e.target.closest?.('[data-ev-consent-input]');
    if (!input) return;
    write(input.checked);
    syncInputs();
    const box = input.closest('[data-ev-consent]');
    if (input.checked && box) box.querySelector('.ev-consent__error').hidden = true;
  });

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest?.('[name="checkout"], .cart__checkout-button');
      if (!btn) return;
      const scope = btn.closest('.cart__ctas') || document;
      const input = scope.querySelector('[data-ev-consent-input]');
      if (!input || input.checked) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const box = input.closest('[data-ev-consent]');
      const err = box?.querySelector('.ev-consent__error');
      if (err) err.hidden = false;
      box?.classList.remove('is-shaking');
      void box?.offsetWidth;
      box?.classList.add('is-shaking');
      input.focus();
    },
    true
  );

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('#cart-form, form[action*="/cart"]')) return;
      const submitter = e.submitter;
      if (submitter && submitter.name !== 'checkout') return;
      const input = document.querySelector('.cart__ctas [data-ev-consent-input]');
      if (input && !input.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  /* Sepet önerisi "Ekle" */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest?.('[data-ev-cart-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.evCartAdd;
    btn.classList.add('is-loading');
    try {
      const actions = window.Shopify?.actions;
      let done = false;
      if (actions?.updateCart) {
        try {
          const res = await actions.updateCart({
            lines: [{ merchandiseId: `gid://shopify/ProductVariant/${id}`, quantity: 1 }],
          });
          done = !res?.userErrors?.length;
        } catch (err) {
          done = false;
        }
      }
      if (!done) {
        await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        });
        window.location.reload();
      }
    } catch (err) {
      console.warn('[evinim] Sepete eklenemedi', err);
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  const start = () => {
    syncInputs();
    if ('MutationObserver' in window) {
      new MutationObserver(syncInputs).observe(document.body, { childList: true, subtree: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
